import React from "react";
import { Container } from "react-bootstrap";
import "../assets/styles/HowWeHelp.css";

const HowWeHelp = () => {
  return (
    <Container fluid className="help-section">
      <div className="help-content text-center">
        
        <h2>How can we help you?</h2>
        <p>
          Are you ready to push boundaries and explore new frontiers of
          innovation?
        </p>
        <button className="help-button">Let's Work Together</button>
      </div>
    </Container>
  );
};

export default HowWeHelp;
